<template>
  <div
    :class="{
      'fsb-Button-active': opened,
      'fsb-Button-disabled': disabled,
      'fsb-Button-outline': outlineButtonStyle
    }"
    :style="{
      '--color': option.color,
      '--rgb-color': option.rgbColor,
      '--text-color': option.textColor
    }"
    class="fsb-Button"
  >
    <AppIcon
      :height="getIconSize"
      :icon-name="getIconName"
      :width="getIconSize"
      class="fsb-Button_Icon"
    />

    <div class="fsb-Button_Content oboard-truncated-text">
      <slot> {{ option.label }}</slot>
    </div>
    <AppIcon
      v-if="!disabled"
      :height="getIconSize"
      :width="getIconSize"
      class="fsb-Button_Icon fsb-Button_Chevron"
      icon-name="arrow-down-black-next"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

import { STATUS_MODES_ICONS } from '@/utils/element-status'

import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'FormStatusButton'
})

const props = defineProps({
  option: {
    type: Object,
    required: true
  },

  opened: {
    type: Boolean
  },

  disabled: {
    type: Boolean
  },

  outlineButtonStyle: {
    type: Boolean
  },

  basedOnGrade: {
    type: Boolean
  }
})

const getIconSize = computed(() => {
  if (props.outlineButtonStyle) {
    return 20
  }

  return 24
})

const getIconName = computed(() => {
  return props.basedOnGrade ? STATUS_MODES_ICONS.AUTO : STATUS_MODES_ICONS.MANUAL
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixins';
.fsb-Button {
  display: flex;
  align-items: center;
  // gap: var(--status-button-gap, 4px);
  gap: var(--status-button-gap, 0);

  border-radius: $border-radius-sm-next;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  color: var(--text-color, #{$white});
  background-color: var(--color);
  font-family: $system-ui;
  font-size: $fs-12;
  text-transform: uppercase;
  line-height: 20px;
  font-weight: fw('semi-bold');

  &:not(&-disabled) {
    // padding: var(--status-button-padding, 4px 4px 4px 12px);
    padding: var(--status-button-padding, 4px);
  }

  &-outline {
    border: 2px solid rgba(var(--rgb-color), 0.3);
    color: var(--color);
    background-color: $white;
    &:not(&-disabled) {
      padding: 0 0 0 6px;
    }
  }

  &-disabled {
    // padding: 4px 12px;
    padding: 4px 10px 4px 4px;
    cursor: default;
  }
}

.fsb-Button_Icon {
  flex-shrink: 0;
}

.fsb-Button_Chevron {
  transition: transform $transition-fast ease-in-out;
  .fsb-Button-active & {
    transform: rotate(180deg);
  }
}

.fsb-Button_Content {
  flex-grow: 1;
}
</style>
